import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=1d338cfc&"
import script from "./SubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports